/** @deprecated */
export const windowExists =
  typeof window !== "undefined" ? window : ({} as Window);
/** @deprecated use useSessionStorage hook */
export const sessionStorage = windowExists.sessionStorage || null;
